import { defineMessages } from 'react-intl';

// Note: the explicit type annotation is required by this package's
// `--isolatedDeclarations` compiler setting (exported `const`s must have an
// explicit type for declaration emission — TS9010), and matches the convention
// used by every sibling `messages` file in this directory. It cannot be removed
// in favour of `defineMessages` inference here.
export const messages: {
	projectLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	projectLabel: {
		id: 'search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-result.search-graph-project.projectLabel',
		defaultMessage: 'Project',
		description: 'Project noun type label for third-party (e.g. ServiceNow) project search results',
	},
});
